/* Filter real Cartwala frame products by occasion without leaving the Photo Frames page. */
(function(){
  "use strict";
  function init(){
    document.querySelectorAll("[data-cw-frame-catalog]").forEach(function(hub){
      if(hub.dataset.cwFrameReady==="true")return;
      hub.dataset.cwFrameReady="true";
      var tabs=[].slice.call(hub.querySelectorAll("[data-cw-frame-filter]"));
      var items=[].slice.call(hub.querySelectorAll("[data-cw-frame-item]"));
      var empty=hub.querySelector("[data-cw-frame-empty]");
      var heading=hub.querySelector("[data-cw-frame-heading]");
      var count=hub.querySelector("[data-cw-frame-count]");
      var names={all:"All Photo Frames",birthday:"Birthday Frames",anniversary:"Anniversary Frames",love:"Love & Couple Frames",wedding:"Wedding Frames",family:"Family Frames",baby:"Baby & Kids Frames",parents:"Parents Frames",friends:"Friends Frames"};
      function select(category){
        if(!Object.prototype.hasOwnProperty.call(names,category))category="all";
        var visible=0;
        tabs.forEach(function(tab){
          var active=tab.dataset.cwFrameFilter===category;
          tab.classList.toggle("is-active",active);
          tab.setAttribute("aria-pressed",active?"true":"false");
        });
        items.forEach(function(item){
          var groups=(item.dataset.frameGroups||"").split(/\s+/);
          var match=category==="all" || groups.indexOf(category)!==-1;
          item.hidden=!match;
          if(match)visible++;
        });
        if(heading)heading.textContent=names[category];
        if(count)count.textContent=visible+" "+(visible===1?"design":"designs");
        if(empty)empty.hidden=visible!==0;
      }
      tabs.forEach(function(tab){tab.addEventListener("click",function(){select(tab.dataset.cwFrameFilter);});});
      var all=hub.querySelector("[data-cw-frame-view-all]");
      if(all)all.addEventListener("click",function(){select("all");var first=hub.querySelector("[data-cw-frame-filter='all']");if(first)first.focus();});
      select("all");
    });
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
  document.addEventListener("shopify:section:load",init);
})();